import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { Root } from './app/app';
import { initSentry } from './app/monitoring/sentry';

initSentry();

bootstrapApplication(Root, appConfig).catch((err) => console.error(err));
